export default function (Component) {
    Component.options.csv = []
  }